<template>
  <div class="mx-sm-0">
    <div>
      <span
        style="
          font-size: 24px;
          line-height: 32px;
          display: block;
          margin-top: 16px;
        "
        >Thank you for your generosity!</span
      >
      <p style="font-size: 14px; line-height: 22px">
        Your donation will go a long way in helping the migrant worker community
        in Singapore.
      </p>
    </div>
    <div
      class="p-2 mx-sm-auto border px-sm-5 py-sm-4 rounded"
      style="max-width: 650px"
    >
      <div class="d-sm-flex">
        <div style="max-width: 155px">
          <h5>Donor details:</h5>
          <p v-if="checkout.Donor_Type == 'Corporate'" class="font-weight-bold">
            {{ checkout.Organisation_Name }}
          </p>
          <p>
            {{ checkout.Title }} {{ checkout.First_Name }}
            {{ checkout.Last_Name }}<br />
            {{ checkout.Donor_Email }}<br />
            {{ checkout.Donor_Phone }}
          </p>
          <div v-if="checkout.Donor_Type == 'On Behalf'">
            <h6>Donated on behalf of:</h6>
            <p>{{ checkout.On_Behalf_Of }}</p>
            <template v-if="checkout.On_Behalf_Of_Email">
              <h6>Send a message to {{ checkout.On_Behalf_Of_Email }}:</h6>
              <p style="white-space: pre-line">
                {{ checkout.On_Behalf_Of_Msg }}
              </p>
            </template>
          </div>
        </div>
        <div class="" style="text-align: left; width: 100%; margin-left: 80px">
          <h5>Address:</h5>
          {{ checkout.Donor_Address_Line_1 }}<br />
          {{ checkout.Donor_Address_Line_2
          }}<br v-if="checkout.Donor_Address_Line_2" />
          {{ checkout.Donor_Address_Country }}
          {{ checkout.Donor_Address_Postal_Code }}
        </div>
      </div>
      <div class="border rounded py-sm-3 px-sm-4 p-1">
        <div class="grid-2-col text-muted">
          <div class="border-bottom pt-2">Donation Type:</div>
          <div class="border-bottom pt-2" style="text-align: right">
            {{ checkout.Donor_Type }}
          </div>
          <div class="border-bottom pt-2">Payment Method:</div>
          <div class="border-bottom pt-2" style="text-align: right">
            {{ checkout.Donation_Mode }}
          </div>
          <div class="border-bottom pt-2">Donation Amount</div>
          <div class="border-bottom pt-2" style="text-align: right">
            ${{ checkout.Donation_Cash_Value }}
          </div>
          <div class="border-bottom pt-2">Frequency</div>
          <div class="border-bottom pt-2" style="text-align: right">
            {{ freq }}
          </div>
          <div class="pt-4 text-dark">
            <strong style="color: #231f1f">Total</strong>
          </div>
          <div class="pt-4 text-dark" style="text-align: right">
            <strong>${{ checkout.Donation_Cash_Value }}</strong>
          </div>
        </div>
      </div>
      <hr />
      <b-form-group
        label="Tax deduction"
        class="d-flex"
        label-class="font-weight-bold"
        style="margin-top: 32px"
      >
        <p v-if="!checkout.Tax_Deductable_Receipt">N/A</p>
        <div v-else>
          <p v-if="checkout.Donor_Type == 'Corporate'" class="mb-0">
            Credited to UEN:
            <span class="text-monospace text-primary">{{
              checkout.Corporate_UEN
            }}</span>
          </p>

          <p class="mb-1" v-else>
            Credited to NRIC:
            <span class="text-monospace text-primary">{{
              checkout.Donor_NRIC
            }}</span>
          </p>
          <p>
            Receipt Requested? :
            {{ checkout.Tax_Receipt_Email_Copy ? "Yes" : "No" }}
          </p>
        </div>
      </b-form-group>
    </div>

    <hr />
    <template v-if="!paymentSet">
      <p>
        By proceeding to the payment page, you consent to HealthServe Ltd's
        <a href="https://healthserve.org.sg/pdpa-policy/" target="_blank">
          privacy policy.
        </a>
      </p>
      <template v-if="checkout.Donor_Type != 'Anonymous'">
        <b-form-checkbox v-model="checkout.Email_Subscribe"
          >I like to receive the latest updates and news from HealthServe via
          e-mails / SMS / mails</b-form-checkbox
        >
      </template>
      <b-form-checkbox v-model="tnc_agree" name="tnc" required v-if="false"
        >I have read and understood the Terms and Conditions</b-form-checkbox
      >
    </template>

    <div
      class="text-right mt-5 d-flex d-sm-block flex-column-reverse align-items-stretch"
      v-if="!paymentSet"
    >
      <b-button
        class="mr-sm-1 mt-1 mt-sm-0"
        style="padding: 0.5rem 3rem"
        @click="go_back"
        >Back</b-button
      >
      <b-button
        style="padding: 0.5rem 3rem"
        variant="hs-green"
        class="text-white"
        @click="confirm"
        :disabled="!tnc_agree || submitting"
      >
        Proceed to Payment
      </b-button>

      <span class="loader" v-if="submitting">
        <img src="/wp-admin/images/spinner.gif" />
      </span>

      <vue-recaptcha
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        size="invisible"
        sitekey="6Lcqvf4jAAAAAPR5eWb8OD_JDvfiL4_T2H3evY6p"
      >
      </vue-recaptcha>
      <br />
    </div>
    <div v-if="paymentSet">
      <template v-if="paymentMethod == 'Credit / Debit Card'">
        <h5>Pay with card:</h5>
        <card-anon
          :checkout="checkout"
          v-if="checkout.Donor_Type == 'Anonymous'"
          ref="card"
          formid="checkout-pay-form"
          :axios="axios"
        />
        <card
          :checkout="checkout"
          v-else
          ref="card"
          :axios="axios"
          formid="checkout-pay-form"
        />
      </template>
      <paynow :checkout="checkout" v-if="paymentMethod == 'PayNow'" />
      <bank
        :checkout="checkout"
        v-if="paymentMethod == 'Online Bank Transfer'"
      />
      <cheque :checkout="checkout" v-if="paymentMethod == 'Cheque'" />
      <b-form @submit.prevent="submit" id="checkout-pay-form">
        <fieldset :disabled="submitting">
          <div
            class="text-right mt-5 d-flex d-sm-block flex-column-reverse align-items-stretch"
          >
            <b-button class="mr-1" @click="$parent.next_step(0)"
              >Cancel</b-button
            >
            <b-button
              type="submit"
              v-if="paymentMethod == `Credit / Debit Card`"
              variant="primary"
            >
              Donate
            </b-button>
            <template v-else>
              <b-button type="submit" variant="outline-primary" @click="done">
                {{ complete_copy }}
              </b-button>
              <b-button
                type="submit"
                variant="outline-primary"
                @click="later"
                v-if="paymentMethod == `Cheque`"
              >
                I’ll mail my cheque later
              </b-button>
            </template>
            <span class="loader" v-if="submitting">
              <img src="/wp-admin/images/spinner.gif" />
            </span>
          </div>
        </fieldset>
      </b-form>
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import card from "./checkout/card.vue";
import cardAnon from "./checkout/card-anon.vue";
import paynow from "./checkout/paynow.vue";
import bank from "./checkout/bank.vue";
import cheque from "./checkout/cheque.vue";

export default {
  name: "checkout",
  data() {
    return {
      payLater: false,
      submitting: false,
      tnc_agree: true,
    };
  },
  props: {
    checkout: Object,
    axios: Function,
  },
  components: {
    card,
    cardAnon,
    paynow,
    bank,
    cheque,
    VueRecaptcha,
  },
  computed: {
    paymentMethod: {
      get() {
        return this.checkout.Donation_Mode;
      },
      set(type) {
        this.checkout.Donation_Mode = type;
      },
    },
    non_card() {
      return this.checkout.Donation_Frequency === -1;
    },
    paymentSet() {
      return !!this.checkout.Reference;
    },
    freq() {
      switch (this.checkout.Donation_Frequency) {
        case -1:
          return "Once";
        case 1:
          return "Monthly";
        case 6:
          return "Biannually";
        case 12:
          return "Annually";
      }
      return `Every ${this.checkout.Donation_Frequency} Months`;
    },
    complete_copy() {
      switch (this.paymentMethod) {
        case "PayNow":
          return "I’ve completed my donation via PayNow";
        case "Online Bank Transfer":
          return "I’ve completed my donation via Online Bank Transfer";
        case "Cheque":
          return "I’ve mailed out my cheque";
      }
      return "";
    },
  },
  methods: {
    async confirm() {
      // before recaptcha implemented
      //this.submitting = true;
      //await this.set_reference();
      // this.submitting = false;

      // after recaptcha implemented
      this.submitting = true;
      this.$refs.recaptcha.execute();
    },
    onCaptchaVerified: async function (recaptchaToken) {
      const self = this;
      self.$refs.recaptcha.reset();

      this.checkout.recaptchaToken = recaptchaToken;

      try {
        let { data } = await this.axios.post("donations", this.checkout);
        if (data.new_nonce) {
          this.axios.defaults.headers["X-WP-Nonce"] = data.new_nonce;
        }
        if (data.Reference) {
          this.checkout.Reference = data.Reference;
        } else {
          throw "Error";
        }
      } catch (err) {
        console.log(err.message);
        alert(
          "Could not initialized the checkout workflow. Please check your connection and try again. If the problem persists, reload this page. Changes will not be saved."
        );
        return false;
      }
      this.submitting = false;
      return true;
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    async set_reference() {
      try {
        let { data } = await this.axios.post("donations", this.checkout);
        if (data.new_nonce) {
          this.axios.defaults.headers["X-WP-Nonce"] = data.new_nonce;
        }
        if (data.Reference) {
          this.checkout.Reference = data.Reference;
        } else {
          throw "Error";
        }
      } catch {
        alert(
          "Could not initialized the checkout workflow. Please check your connection and try again. If the problem persists, reload this page. Changes will not be saved."
        );
        return false;
      }
      return true;
    },
    go_back() {
      if (this.checkout.Donor_Type == `Anonymous`) {
        this.$parent.$emit(`back`);
        return;
      }
      this.$parent.next_step(1);
    },
    async card() {
      return this.$refs.card.submit();
    },
    later() {
      this.payLater = true;
    },
    done() {
      this.payLater = false;
    },
    async submit() {
      this.submitting = true;
      try {
        //run payments
        if (this.paymentMethod == `Credit / Debit Card`) {
          await this.card();
        } else {
          if (!this.payLater) {
            await this.axios.post("donations/" + this.checkout.Reference, {
              action: "confirm",
            });
          }
        }
      } catch (e) {
        if (e?.response?.data?.message) {
          alert(e?.response?.data?.message);
          if (e?.response?.data?.message == "Payment already processed") {
            window.location.href = "/donation/" + this.checkout.Reference;
          }
        } else {
          // console.log(e);
          alert("We could not process your transaction. Please try again");
        }

        this.submitting = false;
        return;
      }
      this.submitting = false;
      window.location.href = "/donation/" + this.checkout.Reference;
    },
  },
};
</script>

<style lang="scss">
.tq-custom-radio-buttons {
  width: 100%;
  display: block !important;
  label {
    width: 100%;
    display: block;
  }
}
.grid-2-col {
  display: grid;
  grid-template-columns: repeat(2, 50%);
}
.loader {
  display: flex;
  align-items: flex-end;
  margin-left: 10px;
}
</style>
